import * as React from "react";
import { ChangeEvent, ClassAttributes, Component } from "react";

interface FileChooserProp extends ClassAttributes<FileChooser> {
  onFile: (file: File) => void;
  className?: string;
  accept?: string;
  title?: string;
}

class FileChooser extends Component<FileChooserProp> {
  fileElement: HTMLInputElement;

  constructor(props: FileChooserProp) {
    super(props);

    this.fileElement;
  }

  onChangeFile(evt: ChangeEvent<FileList>) {
    evt.preventDefault();

    if (this.fileElement && this.fileElement.files && this.fileElement.files.length > 0) {
      this.props.onFile(this.fileElement.files[0]);

      this.fileElement.value = "";
    }
  }

  onClick(evt: MouseEvent) {
    evt.preventDefault();

    if (this.fileElement) {
      this.fileElement.click();
    }
  }

  render() {
    return (
      <div className={this.props.className} title={this.props.title}>
        <input
          type="file"
          style={{ display: "none" }}
          ref={(elt) => (this.fileElement = elt)}
          accept={this.props.accept || "*"}
          onChange={this.onChangeFile.bind(this)}
        />

        <div onClick={this.onClick.bind(this)}>{this.props.children}</div>
      </div>
    );
  }
}

export default FileChooser;
